export default __webpack_public_path__ + "static/media/endRound4.e8b8605f.mp3";